import { getCookieValue } from './cookieUtils';
import { formatPrice, brandingImporter } from '../utils/index';

export function formattedPrice(price) {
  const { currency } = brandingImporter();
  return formatPrice(Number.parseFloat(price), currency);
}

export function targetedPromotion() {
  const targetedPromotionStoreage = sessionStorage?.getItem('targetedPromotions');
  return targetedPromotionStoreage ? JSON.parse(sessionStorage?.getItem('targetedPromotions')) : null;
}

export function getTargetedPromotion(product) {
  const targetedPromo = targetedPromotion();
  if (!targetedPromo) {
    return null;
  }
  const cookie = `${product.brand}_${product.country}_CHA_CR`;
  const maskedId = getCookieValue(cookie);
  if (maskedId) {
    return targetedPromo[maskedId];
  }
  return null;
}

export function getProductPromotion(product) {
  const targetedPromotion = getTargetedPromotion(product);
  if (!targetedPromotion) return null;
  return (
    targetedPromotion.products?.find(item => {
      return String(item.id) === String(product.id);
    }) || null
  );
}

export function getTargetedPromotionLabel(product, isMobile) {
  if (!getProductPromotion(product)) {
    return null;
  }
  const labelToTranslated = isMobile ? 'targetedPromotion_with' : 'targetedPromotion_withCode';
  return this.$t(labelToTranslated)
    .replace('{price}', formattedPrice(getProductPromotion(product).price_with_promocode))
    .replace('{code}', getTargetedPromotion(product).code);
}
